import {
  IconButton,
  Dialog,
  DialogTitle,
  Button,
  DialogActions,
  colors,
  Divider,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  groupedEquipmentBuyItems,
  groupedEquipmentSellItems,
} from '../Utils/Utils';
import EquipmentSellAndBuyDetailsViewTable from './EquipmentSellAndBuyDetailsViewTable';
import {
  EquipmentBuyAndSellRateType,
  listEquipmentItems,
} from 'api/equipmentApi';

export interface DialogState {
  isBuyRateFormOpen: boolean;
  isSellRateFormOpen: boolean;
  isDetailsViewOpen: boolean;
  editRateData: EquipmentBuyAndSellRateType | null;
  openDetailView?: boolean;
}
interface Props {
  open: boolean;
  selectedItemId?: string;
  handleEquipmentClose?: () => void;
}

function EquipmentDetailsView({
  selectedItemId,
  handleEquipmentClose,
  open,
}: Props) {
  //  const queryClient = useQueryClient();
  const equipmentList = useQuery(['equipment-rate-items'], listEquipmentItems);

  const equipment = equipmentList.data?.find(
    (item) => item?.id.toString() === selectedItemId
  );

  // const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState<EquipmentItem | null>(null);

  // const deleteEquipmentCategory = useMutation(deleteEquipmentCategoryItem, {
  //   onSuccess: async () => {
  //     await queryClient.invalidateQueries(['equipment-rate-items']);
  //   },
  //   onError: (error) => {
  //     console.error('Error deleting equipment item:', error);
  //   },
  // });

  // const handleDelete = async () => {
  //   if (!selectedItem) return;
  //   deleteEquipmentCategory.mutate(selectedItem.id);
  //   setDeleteDialogOpen(false);
  //   setSelectedItem(null);
  //   handleEquipmentClose?.();
  // };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleEquipmentClose}
        maxWidth="lg"
        fullWidth>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: 'white',
            zIndex: 10,
            borderBottom: '1px solid #ddd',
          }}>
          <DialogTitle>{equipment?.name}</DialogTitle>
          <IconButton
            onClick={() => {
              handleEquipmentClose?.();
            }}>
            <CloseIcon />
          </IconButton>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '2rem',
            padding: '2rem',
            width: '100%',
            overflowY: 'scroll',
          }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <EquipmentSellAndBuyDetailsViewTable
              equipment={groupedEquipmentBuyItems(equipment)}
              type="buy"
            />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <EquipmentSellAndBuyDetailsViewTable
              equipment={groupedEquipmentSellItems(equipment)}
              type="sell"
            />
          </div>
        </div>
        {/* <Box sx={{ p: 2 }}>
          {deleteDialogOpen && selectedItem && (
            <ConfirmDeleteDialog
              open={deleteDialogOpen}
              title="Delete Confirmation"
              content={
                <>
                  Are you sure you want to delete the item{' '}
                  <b>{selectedItem?.branchName}</b>?
                  <Alert severity="warning" style={{ marginTop: '1rem' }}>
                    This action is irreversible and will permanently delete the
                    data.
                  </Alert>
                </>
              }
              deleteFunc={async () => {
                await handleDelete();
              }}
              handleReject={() => {
                setDeleteDialogOpen(false);
                setSelectedItem(null);
              }}
              handleClose={() => {
                setDeleteDialogOpen(false);
                setSelectedItem(null);
              }}
            />
          )}
        </Box> */}
        <Divider />
        <DialogActions sx={{ padding: '1.5rem' }}>
          <Button
            onClick={handleEquipmentClose}
            sx={{ color: colors.grey[600], mr: 1 }}>
            Cancel
          </Button>
          {/* {!equipment.isDeleted  && (
              <Button
                onClick={() => {
                  setDeleteDialogOpen && setDeleteDialogOpen(true);
                  setSelectedItem &&
                    setSelectedItem(equipment as EquipmentItem);
                }}
                disableElevation
                startIcon={<DeleteIcon />}
                variant="contained"
                sx={{
                  color: 'white',
                  backgroundColor: theme.palette.error.main,
                  '&:hover': {
                    backgroundColor: theme.palette.error.dark,
                  },
                }}>
                Delete Equipment Records
              </Button>
            )} */}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EquipmentDetailsView;
